import { render } from "./VSingleTreatment.vue?vue&type=template&id=5d103721"
import script from "./VSingleTreatment.vue?vue&type=script&lang=js"
export * from "./VSingleTreatment.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__